import { Box } from "@primer/react";
import { useRef } from "react";
import styles from "./DataGrid.module.css";
import Header from "./Header";
import Rows from "./Rows";
import {
  ICondition,
  IDataGridColumn,
  IDataGridFocusedCell,
  IDataGridSort,
  ISummaryItem,
} from "./type/IDataGridProps";
import Loading from "./Loading";
import TotalSummary from "./TotalSummary";
interface ITableProps {
  dataColumn: IDataGridColumn[];
  stickyOffsets: any;
  height?: number;
  sorting?: IDataGridSort;
  onSortingChanged?: (sorting: IDataGridSort) => void;
  isLoading?: boolean;
  focusedCell?: IDataGridFocusedCell;
  mainColor?: string;
  totalSummary?: ISummaryItem[];
  filterdData: any[];
  dataSource: any[]
  conditions: ICondition[]
}
const Table = (props: ITableProps) => {
  const _wrapperRefTable = useRef<HTMLDivElement>(null);
  const { dataColumn, height, stickyOffsets, sorting, onSortingChanged, filterdData } =
    props;

  return (
    <Box
      ref={_wrapperRefTable}
      sx={{
        overflow: "auto",
        position: "relative",
        borderRadius: 2,
        border: "1px solid",
        borderColor: "border.muted",
        height: height,
      }}
    >
      <table
        className={styles.table}
        style={{
          tableLayout: "fixed",
        }}
      >
        <colgroup>
          {dataColumn.map((col, idx) => {
            return <col key={idx} style={{ width: col.width ?? 100 }} />;
          })}
        </colgroup>
        <Header
          stickyOffsets={stickyOffsets}
          dataColumns={dataColumn}
          sorting={sorting}
          onSortingChanged={onSortingChanged}
          dataSource={props.dataSource}
          conditions={props.conditions}
        />

        {props.isLoading && <Loading dataColumn={dataColumn} />}
        {!props.isLoading && (
          <Rows
            stickyOffsets={stickyOffsets}
            dataColumns={dataColumn}
            focusedCell={props.focusedCell}
            mainColor={props.mainColor}
          />
        )}
        {props.totalSummary && props.totalSummary.length > 0 && (
          <TotalSummary
            dataColumns={dataColumn}
            totalSummary={props.totalSummary ?? []}
            stickyOffsets={stickyOffsets}
            filterdData={filterdData}
          />
        )}
      </table>
    </Box>
  );
};

export default Table;
